import { RequestConfig } from '~/common/services/requests';
import { TokenPayload } from '../../../types/apis';
import { LoginData } from '../../../types/requests';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { AUTH_BASE_PATH } from '../constants/authenticationPath';

export const postLogin = (
  constructPost: ConstructPost,
  data: LoginData,
  headers?: Record<string, string>,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<TokenPayload> | undefined> =>
  constructPost<NonPaginatedResponse<TokenPayload>>(
    `${AUTH_BASE_PATH}/login`,
    { data, headers, params },
    { preventDefaultErrorToast: true },
  );
